var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sizeW)?_c('v-content',[_c('mobile-cards',{attrs:{"domain":_vm.enterprise.Domain,"locale":_vm.locale,"isTotem":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }